<template>
  <div class="vote-container">
    <AppNavbar
      :options="options"
      :title="title"
      :zIndex="1000"
      :placeholder="false"
    >
      <div slot="right">
        <div class="share" @click="bindShare"
          ><span class="iconfont icon-share1"></span
        ></div>
      </div>
    </AppNavbar>
    <div class="p-content">
      <div v-if="userInfo && activityInfo">
        <div
          class="rule"
          @click="bindToRule"
          :style="{ top: statusBarHeight + 80 + 'px' }"
          >活动规则</div
        >
        <div class="v-time"
          >活动时间：{{ activityInfo.activityInfo.begin_time | filterTime }}-{{
            activityInfo.activityInfo.end_time | filterTimeLessOneDay
          }}</div
        >
        <PrizeContainer
          class="prize-container"
          :data="userInfo.rewards"
          :voteNum="userInfo.voted_num"
          @preview="bindClickPrize"
        />
        <RankContainer
          :userInfo="userInfo"
          :coachInfo="coachInfo"
          @vote="bindRankVote"
          @invite="bindRankInvite"
          @avatar="bindClickAvatar"
          @get="bindGetByRank"
          @inviteDetail="bindToInviteDetail"
        />
        <div class="desc-container">
          <div class="text1">截止2023年底，我们的营养师已经</div>
          <div class="text2"
            >帮助了<span class="pink">53.2万人</span>，成功瘦身<span
              class="pink"
              >297.8万斤</span
            ></div
          >
        </div>
        <DynamicContainer />
        <TaskToast
          ref="task"
          v-model="showTaskToast"
          :activityInfo="activityInfo"
          :userInfo="userInfo"
          :activityId="activityId"
          @invite="bindInviteFriend"
          @complete="bindCompleteTask"
        />
        <VoteToast
          v-model="showVoteToast"
          :data="voteToastInfo"
          :voteNum="userInfo.user_vote_num"
          @vote="bindVote"
          @get="bindGet"
        />
        <CanvassingVotesToast
          v-model="showInviteDetailToast"
          :data="inviteList"
          :activityId="activityId"
        />
        <PosterContainer ref="poster" :qrcode="qrcodeUrl" :data="userInfo" />
        <PrizeToast
          v-model="showPrizeToast"
          :data="prizeToastInfo"
          @receive="receivePrize"
        />
        <ConsultToast v-model="showConsultToast" />
        <ShareComponent
          v-model="showShare"
          :posterUrl="posterUrl"
          :options="iconList"
          @cancel="bindCancel"
          @select="bindSelect"
          :qrcodeUrl="qrcodeUrl"
          zIndex="9999"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PrizeContainer from './components/prize.vue'
import RankContainer from './components/rank.vue'
import DynamicContainer from './components/dynamic.vue'
import TaskToast from './components/task-toast.vue'
import VoteToast from './components/vote-toast.vue'
import CanvassingVotesToast from './components/canvassing-votes-toast.vue'
import PosterContainer from './components/poster.vue'
import PrizeToast from './components/prize-toast.vue'
import ConsultToast from './components/consult-toast.vue'
import ShareComponent from '@/components/app/share/share.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import {
  eventObj,
  defultShareIcons,
  shareImageIcons,
  shareCopyBtn
} from '@/components/app/share/share-method.js'

export default {
  components: {
    PrizeContainer,
    RankContainer,
    DynamicContainer,
    TaskToast,
    VoteToast,
    CanvassingVotesToast,
    PosterContainer,
    PrizeToast,
    ShareComponent,
    AppNavbar,
    ConsultToast
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(74,61,107,0)'
      },
      title: '',
      statusBarHeight: 0,
      showPoster: false,
      userInfo: null,
      activityInfo: null,
      coachInfo: [],
      voteToastInfo: null, //投票弹窗信息
      showVoteToast: false, //是否显示投票弹窗
      prizeToastInfo: null, //奖品弹窗信息
      showPrizeToast: false, //是否显示奖品弹窗
      showTaskToast: false, //是否显示任务列表弹窗
      showInviteDetailToast: false, //是否显示邀请明细弹窗
      showConsultToast: false,
      normalIconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 8
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 9
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接',
          id: 10,
          copy: true,
          className: shareCopyBtn
        }
      ],
      showShare: false,
      qrcodeUrl: '',
      iconList: [],
      posterUrl: '',
      shareOptions: {
        //分享参数
        url: '',
        desc: '我的体质评估报告',
        title: '93.6%的易胖困扰，都来自长期体质问题哦！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image'
      },
      /* 首页分享参数 */
      homeShareOptions: {
        url: '',
        desc: '参与投票有机会领取真人营养师服务>>>',
        title: '人气营养师pick赛，速来投票！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/200d5706b3dae6d0270a58c261c9d149.png'
      },
      /* 邀请好友分享参数 */
      inviteShareOptions: {
        url: '',
        desc: '点击领取真人营养师服务>>>',
        title: '据说有人跟营养师吃瘦了10斤！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png'
      },
      /* 拉票分享参数 */
      voteShareOptions: {
        url: '',
        desc: '参与投票有机会领取真人营养师服务>>>',
        title: '人气营养师pick赛，速来投票！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/200d5706b3dae6d0270a58c261c9d149.png'
      },
      inviteList: [
        {
          name: '张三',
          time: '2024.01.03 11:12:59'
        },
        {
          name: '张三',
          time: '2024.01.03 11:12:59'
        },
        {
          name: '张三',
          time: '2024.01.03 11:12:59'
        },
        {
          name: '张三',
          time: '2024.01.03 11:12:59'
        }
      ]
    }
  },
  filters: {
    filterTime(str) {
      str = str.replace(/-/g, '/')
      let time = new Date(str)
      let month = time.getMonth() + 1
      let day = time.getDate()
      return month + '月' + day + '日'
    },
    filterTimeLessOneDay(str) {
      str = str.replace(/-/g, '/')
      let time = new Date(new Date(str).getTime() - 1000 * 60 * 60 * 24)
      let month = time.getMonth() + 1
      let day = time.getDate()
      return month + '月' + day + '日'
    }
  },
  computed: {
    activityId() {
      return this.$route?.query?.activityId || 1
    }
  },
  created() {
    this.getUserInfo()
    this.getCoachInfo()
    this.getActivityInfo()
    this.addEventPage()
    this.getAppBarHeight()
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    async getAppBarHeight() {
      let res = await this.$betterwe.getAppBarHeight()
      if (res) {
        this.statusBarHeight = res.statusBarHeight
      }
    },
    bindShare() {
      if (this.bindShowConsult()) {
        return
      }
      if (!this.checkActivity()) {
        return
      }
      let uid = this.activityInfo.userPlan.unify_id
      if (!uid) {
        this.$toast('未获取到用户信息,请刷新后重试')
        return
      }
      this.iconList = this.normalIconList
      this.shareOptions = this.homeShareOptions
      this.qrcodeUrl =
        location.origin +
        '/dietitian-vote/rank?uid=' +
        uid +
        '&aid=' +
        this.activityId
      this.showShare = true
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset

      if (scrollTop >= 100) {
        this.title = '营养师投票'
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, 1)',
          color: 'rgba(0,0,0,0.8)'
        }
      } else {
        this.title = ''
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(74,61,107,0)'
        }
      }
    },
    addEventPage() {
      window.onPageResumed = () => {
        this.getUserInfo()
        this.$refs.task.getTaskList()
      }
    },
    //点击营养师头像
    async bindClickAvatar(item) {
      this.$toast.loading({ message: '加载中...' })
      let params = {
        cid: item.coach_id
      }
      let res = await this.$http
        .getApp('api/v1/Vote/getExpertIdByCoachId', params)
        .catch(() => {
          this.$toast('异常错误')
          this.$toast.clear()
        })
      if (res) {
        this.$toast.clear()
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            this.$betterwe.jumpRoute('/dietitianDetails?id=' + res.data)
          } else {
            this.$toast('暂无该营养师档案')
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindToRule() {
      let startTime = this.activityInfo.activityInfo.begin_time.replace(
        /-/g,
        '/'
      )
      let start = new Date(startTime)
      let endTime = this.activityInfo.activityInfo.end_time.replace(/-/g, '/')
      let end = new Date(new Date(endTime).getTime() - 1000 * 60 * 60 * 24)
      let startStr = start.getMonth() + 1 + '月' + start.getDate() + '日'
      let endStr = end.getMonth() + 1 + '月' + end.getDate() + '日'
      this.$router.push({
        path: '/dietitian-vote/rule',
        query: {
          start: startStr,
          end: endStr
        }
      })
    },
    bindShowVoteToast() {
      this.showVoteToast = true
    },
    bindRankVote(item) {
      if (this.bindShowConsult()) {
        return
      }
      if (!this.checkActivity()) {
        return
      }
      this.showVoteToast = true
      this.voteToastInfo = item
    },
    //检查活动时间
    checkActivity() {
      if (this.activityInfo.activityInfo.activity_state == 2) {
        this.$toast('活动未开始')
        return false
      } else if (this.activityInfo.activityInfo.activity_state == 3) {
        this.$toast('活动已结束')
        return false
      }
      return true
    },
    //拉票
    bindRankInvite(item) {
      if (this.bindShowConsult()) {
        return
      }
      if (!this.checkActivity()) {
        return
      }
      let uid = this.activityInfo.userPlan.unify_id
      if (!uid) {
        this.$toast('未获取到用户信息,请刷新后重试')
        return
      }
      this.curInviteInfo = item
      this.iconList = this.normalIconList
      this.shareOptions = this.voteShareOptions
      this.qrcodeUrl =
        location.origin +
        '/dietitian-vote/vote?cid=' +
        item.coach_id +
        '&uid=' +
        uid +
        '&aid=' +
        this.activityId
      this.showShare = true
    },
    bindClickPrize(item) {
      this.prizeToastInfo = item
      this.showPrizeToast = true
    },
    bindToInviteDetail() {
      if (this.bindShowConsult()) {
        return
      }
      this.showInviteDetailToast = true
    },
    bindCancel() {
      this.iconList = defultShareIcons
      this.showShare = false
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        case 1:
          let createQrcode = await this.$refs.poster
            .createQrcode()
            .catch(() => {})
          if (createQrcode) {
            let url = await eventObj
              .createPoster('vote-poster')
              .catch((err) => {})
            this.posterUrl = url
            this.iconList = shareImageIcons
            this.showShare = true
          }
          break
        // 分享链接到微信好友
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 3:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        case 5:
          eventObj.saveImageToPhone(this.posterUrl)
          break
        case 6:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxFriend(shareOptions)
          break
        case 7:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxCircle(shareOptions)
          break
        case 8:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        case 9:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        case 10:
          break
      }
    },
    /* 投票接口 */
    async bindVote(num) {
      let params = {
        cid: this.voteToastInfo.coach_id,
        num,
        activity_id: this.activityId
      }
      let res = await this.$http
        .postApp('api/v1/Vote/ticketVote', params)
        .catch(() => {
          this.$toast('异常错误')
        })
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.showVoteToast = false
          this.$toast('投票成功')
          this.getUserInfo()
          this.getCoachInfo()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 获取投票 */
    bindGet() {
      this.showVoteToast = false
      setTimeout(() => {
        this.showTaskToast = true
      }, 300)
    },
    bindGetByRank() {
      if (this.bindShowConsult()) {
        return
      }
      this.showTaskToast = true
    },
    //邀请好友
    bindInviteFriend() {
      let uid = this.activityInfo.userPlan.unify_id
      if (!uid) {
        this.$toast('未获取到用户信息,请刷新后重试')
        return
      }
      console.log(uid)
      this.showTaskToast = false
      setTimeout(() => {
        this.iconList = defultShareIcons
        this.shareOptions = this.inviteShareOptions
        this.qrcodeUrl =
          location.origin +
          '/dietitian-vote/invite?uid=' +
          uid +
          '&aid=' +
          this.activityId
        this.showShare = true
      }, 400)
    },
    //领取奖励
    async receivePrize(data) {
      if (this.bindShowConsult()) {
        return
      }
      this.showPrizeToast = false
      if (!data.reach_type) {
        /* 未达成 */
      } else if (!data.received_status) {
        /* 已达成并且没有领取 */
        let res = await this.$http
          .postApp('api/v1/Vote/receiveReward', {
            reward_id: data.id,
            activity_id: this.activityId
          })
          .catch(() => {
            this.$toast('异常错误')
          })
        if (res) {
          res = res.data
          if (res.code == 200) {
            this.$betterwe.jumpRoute(data.jump_url)
          } else {
            this.$toast(res.msg)
          }
        }
      } else {
        this.$betterwe.jumpRoute(data.jump_url)
      }
    },
    async getUserInfo() {
      let params = {
        activity_id: this.activityId
      }
      let res = await this.$http
        .getApp('api/v1/Vote/getUserInfo', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.userInfo = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getCoachInfo() {
      let params = {
        activity_id: this.activityId
      }
      let res = await this.$http
        .getApp('api/v1/Vote/getAllCoachInfo', params)
        .catch(() => {
          this.$toast('异常错误')
        })
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.coachInfo = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getActivityInfo() {
      let params = {
        activity_id: this.activityId
      }
      let res = await this.$http
        .postApp('api/v1/Vote/getActivityBaseInfo', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityInfo = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindCompleteTask() {
      this.getUserInfo()
    },
    //是否显示联系营养师
    bindShowConsult() {
      if (!this.userInfo.qualified) {
        this.showConsultToast = true
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.vote-container {
  min-height: 100vh;
  overflow: hidden;

  .share {
    .iconfont {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.8);
      font-size: 600;
    }
  }

  .rule {
    position: fixed;
    right: 0;
    top: 80px;
    z-index: 33;
    width: 28px;
    text-align: center;
    box-sizing: border-box;
    padding: 8px 6px 11px;
    background: #4a3d6b;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    color: #ffffff;
    line-height: 14px;
    border-radius: 8px 0px 0px 8px;
  }

  .p-content {
    box-sizing: border-box;
    min-height: 100vh;
    padding: 143px 16px 52px;
    position: relative;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ef96b96ed2afa0eb601a22db799a0505.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center top;
    background-color: #f3e9ff;
  }

  .v-time {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: rgba(74, 61, 107, 0.5);
    line-height: 16px;
    margin-bottom: 12px;
  }

  .prize-container {
    margin-bottom: 15px;
  }

  .desc-container {
    padding: 0px 15px;
    margin-bottom: 18px;

    .text1 {
      font-size: 14px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 8px;
    }

    .text2 {
      font-size: 18px;
      font-family: MiSans, MiSans;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;

      .pink {
        font-weight: bold;
        font-family: '';
        color: rgba(255, 106, 151, 1);
      }
    }
  }
}
</style>
